module.exports = __webpack_public_path__ + "img/SieIstSOOSchrecklich.985cc1d8.svg";